import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/index";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css"; // 引入 Swiper 样式
import "./components";
import "@/plugins/passive";

import "@/plugins/dayjs";
import "@/plugins/element";
import "@/plugins/vant";
import HcUI from "@/plugins/hc-ui";


import globalMixin from "@/mixins/global";
// import "@/tools/error-handler";

Vue.use(HcUI);
Vue.mixin(globalMixin);
Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper);


new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js